// GAEA-JS: 2026-10-23 — Seguro de variante y talla obligatoria: fija el id correcto al agregar y exige elegir talla antes de comprar
(function () {
  'use strict';

  // GAEA-JS: 2026-10-23 — Texto del aviso cuando falta elegir talla
  var MENSAJE_TALLA = 'Selecciona tu talla para continuar';

  // GAEA-JS: 2026-10-23 — Formularios donde el cliente ya eligió talla de forma explícita, indexados por id de formulario
  var tallaElegida = {};

  // GAEA-JS: 2026-10-23 — Id del formulario leído del atributo, porque form.id devuelve el input name="id"
  function idDe(form) {
    return form && form.getAttribute ? form.getAttribute('id') || '' : '';
  }

  // GAEA-JS: 2026-10-23 — Opciones marcadas del producto, asociadas al formulario por el atributo form
  function opcionesMarcadas(form) {
    var marcadas = [];
    document.querySelectorAll('[data-single-option-selector][form="' + idDe(form) + '"]').forEach(function (el) {
      if (el.type === 'radio' && !el.checked) return;
      var pos = parseInt(String(el.getAttribute('data-index')).replace('option', ''), 10);
      if (pos) marcadas[pos - 1] = el.value;
    });
    return marcadas;
  }

  // GAEA-JS: 2026-10-23 — Leer el mapa de variantes que pertenece a este formulario
  function leerMapa(form) {
    var script = document.querySelector('script[data-variant-map][data-form-id="' + idDe(form) + '"]');
    try { return script ? JSON.parse(script.textContent) : null; } catch (e) { return null; }
  }

  // GAEA-JS: 2026-10-23 — Devolver el contenedor de talla si es de botones y ninguno está marcado
  function tallaSinElegir(form) {
    var ref = document.querySelector('[data-size-option] [data-single-option-selector][form="' + idDe(form) + '"]');
    if (!ref) return null;
    var contenedor = ref.closest('[data-size-option]');
    var radios = contenedor.querySelectorAll('input[type="radio"][data-single-option-selector]');
    if (!radios.length) return null;
    return Array.prototype.some.call(radios, function (r) { return r.checked; }) ? null : contenedor;
  }

  // GAEA-JS: 2026-10-23 — Botones de envío asociados a un formulario, estén dentro de él o enlazados con el atributo form
  function botonesDe(formId) {
    var lista = Array.prototype.slice.call(document.querySelectorAll('button[type="submit"][form="' + formId + '"]'));
    var formEl = document.getElementById(formId);
    if (formEl) {
      formEl.querySelectorAll('button[type="submit"]').forEach(function (b) {
        if (lista.indexOf(b) === -1) lista.push(b);
      });
    }
    return lista;
  }

  // GAEA-JS: 2026-10-23 — Mantener las tallas desmarcadas y el botón en gris hasta que el cliente elija una talla
  function aplicarTallaObligatoria() {
    document.querySelectorAll('[data-size-option]').forEach(function (cont) {
      var radios = cont.querySelectorAll('input[type="radio"][data-single-option-selector]');
      if (radios.length < 2) return;
      var formId = radios[0].getAttribute('form') || '';
      if (!formId) return;
      var elegida = !!tallaElegida[formId];
      if (!elegida) {
        radios.forEach(function (r) { if (r.checked) r.checked = false; });
      }
      botonesDe(formId).forEach(function (b) {
        if (elegida) {
          b.removeAttribute('aria-disabled');
          b.removeAttribute('data-gaea-talla');
        } else {
          b.setAttribute('aria-disabled', 'true');
          b.setAttribute('data-gaea-talla', '');
        }
      });
    });
  }

  // GAEA-JS: 2026-10-23 — Mostrar el aviso en una fila propia, justo debajo de los botones de talla, y llevar la vista hasta ahí
  function mostrarAviso(contenedor) {
    contenedor.classList.add('gaea-talla-error');
    if (!contenedor.querySelector('.gaea-talla-aviso')) {
      var aviso = document.createElement('p');
      aviso.className = 'gaea-talla-aviso';
      aviso.setAttribute('role', 'alert');
      aviso.textContent = MENSAJE_TALLA;
      var fieldset = contenedor.querySelector('.radio__fieldset') || contenedor;
      var botones = fieldset.querySelector('.radio__buttons');
      if (botones) {
        botones.insertAdjacentElement('afterend', aviso);
      } else {
        fieldset.appendChild(aviso);
      }
    }
    contenedor.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // GAEA-JS: 2026-10-23 — Corregir el id del formulario, o bloquear el envío si falta la talla
  function proteger(evento, form) {
    var formId = idDe(form);
    if (formId.indexOf('AddToCartForm') !== 0) return;

    var sinTalla = tallaSinElegir(form);
    if (sinTalla) {
      evento.preventDefault();
      evento.stopImmediatePropagation();
      mostrarAviso(sinTalla);
      return;
    }

    var mapa = leerMapa(form);
    var inputId = form.querySelector('input[name="id"]');
    if (!mapa || !inputId) {
      console.warn('GAEA-JS guard: sin mapa de variantes o sin input id para', formId);
      return;
    }

    var marcadas = opcionesMarcadas(form);
    var variante = mapa.find(function (v) {
      return v.options.every(function (o, i) { return o === marcadas[i]; });
    });
    if (!variante) {
      console.warn('GAEA-JS guard: no hay variante para', marcadas);
      return;
    }
    if (String(variante.id) !== String(inputId.value)) {
      // GAEA-JS: 2026-10-23 — Registrar solo cuando el seguro corrige el id, sin ruido en el flujo normal
      console.info('GAEA-JS guard: id corregido', inputId.value, '->', variante.id);
      inputId.value = variante.id;
    }
  }

  // GAEA-JS: 2026-10-23 — Escuchar en fase de captura para correr antes que el JavaScript del theme
  document.addEventListener('submit', function (e) { proteger(e, e.target); }, true);
  document.addEventListener('click', function (e) {
    var boton = e.target.closest ? e.target.closest('button[type="submit"], input[type="submit"]') : null;
    if (boton && boton.form) proteger(e, boton.form);
  }, true);

  // GAEA-JS: 2026-10-23 — Registrar la talla elegida por el cliente y quitar el aviso apenas elige
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-size-option] [data-single-option-selector]')) return;
    if (e.isTrusted && el.type === 'radio') {
      tallaElegida[el.getAttribute('form') || ''] = true;
      aplicarTallaObligatoria();
    }
    var contenedor = el.closest('[data-size-option]');
    contenedor.classList.remove('gaea-talla-error');
    var aviso = contenedor.querySelector('.gaea-talla-aviso');
    if (aviso) aviso.remove();
  }, true);

  // GAEA-JS: 2026-10-23 — Reaplicar la regla cada vez que el theme redibuja las tallas, también en la vista rápida
  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      aplicarTallaObligatoria();
    });
  }
  new MutationObserver(programar).observe(document.documentElement, { childList: true, subtree: true });
  aplicarTallaObligatoria();
})();